import { getState, select } from '@ps/web-core-store';

import {
  TXTCLI_Please_try_againX,
  TXTCLI_The_SSN_that_you_have_entered__ELL
} from './compareWithNatNumber.messages';

export const compareWithNatNumber = (value: string) => {
  const natNum = Number(select.account.getNationalDocumentNumber(getState()));

  if (!natNum) return { valid: true };

  if (Number(value) !== natNum) {
    return {
      valid: false,
      message: [TXTCLI_The_SSN_that_you_have_entered__ELL, TXTCLI_Please_try_againX]
    };
  }

  return {
    valid: true
  };
};
